const buttonTimeActions = {
  text: 'Send'
};

export default buttonTimeActions;
